const books = [
    {
        title: "Revelations of Divine Love",
        author: "Julian of Norwich",
        baseUrl: "https://ccel.org/ccel/julian/revelations",
        urlName: "revelations",
        link: "https://ccel.org/ccel/julian/revelations/revelations.i.html",
        cover: "https://ccel.org/ccel/julian/revelations/files/revelations-thumb.jpg"
    },
    {
        title: "Practice of the Presence of God",
        author: "Brother Lawrence",
        baseUrl: "https://ccel.org/ccel/lawrence/practice",
        urlName: "practice",
        link: "https://ccel.org/ccel/lawrence/practice/practice.i.html",
        cover: "https://ccel.org/ccel/lawrence/practice/files/practice.jpg"
    },
    {
        title: "The Normal Christian Life",
        author: "Watchman Nee",
        baseUrl: "https://ccel.org/ccel/nee/normal",
        urlName: "normal",
        link: "https://ccel.org/ccel/nee/normal/normal.i.html",
        cover: "https://ccel.org/ccel/nee/normal/files/normal.jpg"
    }
];

export default books;